module.exports = function () {
  return new Worker(__webpack_public_path__ + "a2774359445e1082a53d.worker.js");
};